import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import './Header.css';
import Ingrov from '../assets/images/11.svg';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [hideMenu, setHideMenu] = useState(false); // New state to hide the menu
  const location = useLocation();

  useEffect(() => {
    let lastScrollY = window.scrollY; // Keep track of last scroll position

    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      // If scrolling down and passed a threshold, hide the menu
      if (currentScrollY > 50 && currentScrollY > lastScrollY) {
        setHideMenu(true);
      } else {
        setHideMenu(false);
      }

      // Track whether the user has scrolled down
      setIsScrolled(currentScrollY > 50);
      lastScrollY = currentScrollY;
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''} ${hideMenu ? 'hide' : ''}`}>
      <nav className="navbar">
        <div className="logo">
          <a href="/">
            <img src={Ingrov} alt="INGROV SYSTEMS Logo" />
          </a>
        </div>
        <div className={`menu ${isMobileMenuOpen ? 'open' : ''}`}>
          <ul>
            <li>
              <a
                href="/expertise"
                className={location.pathname === '/expertise' ? 'active' : ''}
              >
                Capabilities
              </a>
            </li>
            <li>
              <a
                href="/leadership"
                className={location.pathname === '/leadership' ? 'active' : ''}
              >
                Leadership
              </a>
            </li>
            <li>
              <a
                href="/history"
                className={location.pathname === '/history' ? 'active' : ''}
              >
                The Company 
              </a>
            </li>
            <li>
              <a
                href="/contacts"
                className={location.pathname === '/contacts' ? 'active' : ''}
              >
                Contacts
              </a>
            </li>
          </ul>
        </div>
        <div className="mobile-menu-icon" onClick={toggleMobileMenu}>
          <div className={`bar ${isMobileMenuOpen ? 'open' : ''}`}></div>
          <div className={`bar ${isMobileMenuOpen ? 'open' : ''}`}></div>
          <div className={`bar ${isMobileMenuOpen ? 'open' : ''}`}></div>
        </div>
      </nav>
    </header>
  );
};

export default Header;
